var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPrinter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 3.5C15.6435 3.5 13.863 4.2375 12.5503 5.55025C11.2375 6.86301 10.5 8.64348 10.5 10.5V14H45.5V10.5C45.5 8.64348 44.7625 6.86301 43.4497 5.55025C42.137 4.2375 40.3565 3.5 38.5 3.5H17.5ZM38.5 31.5H17.5C16.5717 31.5 15.6815 31.8687 15.0251 32.5251C14.3687 33.1815 14 34.0717 14 35V45.5C14 46.4283 14.3687 47.3185 15.0251 47.9749C15.6815 48.6312 16.5717 49 17.5 49H38.5C39.4283 49 40.3185 48.6312 40.9749 47.9749C41.6313 47.3185 42 46.4283 42 45.5V35C42 34.0717 41.6313 33.1815 40.9749 32.5251C40.3185 31.8687 39.4283 31.5 38.5 31.5Z",
    fill: "url(#paint0_linear_55_598)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 24.5C0 22.6435 0.737498 20.863 2.05025 19.5503C3.36301 18.2375 5.14348 17.5 7 17.5H49C50.8565 17.5 52.637 18.2375 53.9497 19.5503C55.2625 20.863 56 22.6435 56 24.5V35C56 36.8565 55.2625 38.637 53.9497 39.9497C52.637 41.2625 50.8565 42 49 42H45.5V35C45.5 33.1435 44.7625 31.363 43.4497 30.0503C42.137 28.7375 40.3565 28 38.5 28H17.5C15.6435 28 13.863 28.7375 12.5503 30.0503C11.2375 31.363 10.5 33.1435 10.5 35V42H7C5.14348 42 3.36301 41.2625 2.05025 39.9497C0.737498 38.637 0 36.8565 0 35V24.5ZM8.75 28C9.21413 28 9.65925 27.8156 9.98744 27.4874C10.3156 27.1592 10.5 26.7141 10.5 26.25C10.5 25.7859 10.3156 25.3408 9.98744 25.0126C9.65925 24.6844 9.21413 24.5 8.75 24.5C8.28587 24.5 7.84075 24.6844 7.51256 25.0126C7.18437 25.3408 7 25.7859 7 26.25C7 26.7141 7.18437 27.1592 7.51256 27.4874C7.84075 27.8156 8.28587 28 8.75 28Z",
    fill: "url(#paint1_linear_55_598)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_55_598",
    x1: 28,
    y1: 3.5,
    x2: 28,
    y2: 49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C1B43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E3EBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_55_598",
    x1: 28,
    y1: 17.5,
    x2: 28,
    y2: 42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C1B43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E3EBB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinter);
export default __webpack_public_path__ + "static/media/printer.04f09837a3683cfb6711db6893a593e7.svg";
export { ForwardRef as ReactComponent };